export default "__VITE_ASSET__BhP1sOc9__"